const GlobalData = {
  company: {
    companyName: "Shishu Hriday Heart Foundation",
    companyPhone: "+91 9000543222",
    companyEmail: "mail@shishuhriday.com",
    companyAddress: "Visakhapatnam, Andhra Pradesh",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=919000543222",

    /*Social media */
    companyfacebook: "https://www.facebook.com/shishuhriday",
    companyinstagram: "https://www.instagram.com/shishuhriday",
    companygit: "https://github.com/shishuhriday",
    companytwitter: "https://twitter.com/shishuhriday",
    companyyoutube: "https://youtube.com/shishuhriday",
    companylinkedin: "https://linkedin.com/company/shishuhriday",
  },

  developerdetails: {
    developerName: "Cyber Space Digital",
    developerCompany: "Cyber Space Digital",
    developerPhone: "+91 81434 07758",
    developerEmail: "mail@cyberspacedigital.in",
    developerAddress: "Visakhapatnam, Andhra Pradesh 530017",
    developerWhatsapp: "https://api.whatsapp.com/send?phone=918143407758",
  },
};

export { GlobalData };
